<!--
 * @Author: ZhaoDong
 * @Date: 2022-10-24 13:54:40
 * @LastEditors: Anxure
 * @LastEditTime: 2026-10-13 10:57:46
 * @Description: 优惠券详情
-->
<template>
  <div class="coupon-detail-container">
    <a-card >
      <div slot="title" class="flex-sa-ac" style="width:100%;font-size:14px;font-weight: normal;">
        查看优惠券
        <a @click="back">返回</a>
      </div>
      <a-row :gutter="[80,40]">
        <a-col :span="12" >
          <a-descriptions :column="1">
            <div slot="title" class="flex-sa-ac" style="width:100%;">
              <span>基本信息</span>
              <span class="couponId">（优惠券ID: {{ couponID }}）</span>
            </div>
            <a-descriptions-item label="优惠券属性">
              {{ showName('COUPON_PROPERTY', detailData.coupon_property) }} <a>（{{ couponName }}）</a>
            </a-descriptions-item>
            <a-descriptions-item label="优惠券名称">
              {{ detailData.coupon_name }}
            </a-descriptions-item>
            <a-descriptions-item label="优惠券类型">
              {{ showName('COUPON_TYPE', detailData.coupon_type) }}
            </a-descriptions-item>
            <a-descriptions-item label="优惠面额">
              {{ detailData.coupon_type == 1 ? `${detailData.coupon_amount}元` : `${detailData.coupon_amount}折` }}
            </a-descriptions-item>
            <a-descriptions-item label="使用门槛">
              {{ +detailData.coupon_threshold == 0 ? '无门槛' : `满${+detailData.coupon_threshold}可用` }}
            </a-descriptions-item>
            <a-descriptions-item label="使用说明">
              {{ detailData.coupon_desc || '-' }}
            </a-descriptions-item>
          </a-descriptions>
        </a-col>
        <a-col :span="12">
          <a-descriptions title="发放和领取" :column="1">
            <a-descriptions-item label="领取方式">
              {{ showName('COUPON_WAY', detailData.coupon_way) }}
            </a-descriptions-item>
            <a-descriptions-item label="发放用户">
              <!-- // 发放用户 1.所有用户 2. 新增注册用户 3. 指定用户' -->
              <template v-if="detailData.coupon_target === '1'">所有用户</template>
              <template v-if="detailData.coupon_target === '2'">
                新注册用户
                <template v-if="detailData.user_reg_start_at && detailData.user_reg_start_at !== '0'">
                  注册时间（{{ detailData.user_reg_start_at | formatDate }} 至 {{ detailData.user_reg_end_at | formatDate }}）
                </template>
              </template>
              <template v-if="detailData.coupon_target === '3'">
                <a-space v-if="detailData.useUsers.userInfo">指定用户可领：
                  <a-tag class="flex-wrap" color="blue" v-for="user in detailData.useUsers" :key="user.user_id">
                    {{ user.userInfo.username }}
                  </a-tag>
                </a-space>
              </template>
            </a-descriptions-item>
            <a-descriptions-item label="发放总量">
              <a-space>
                <template v-if="couponNum == 0">不限</template>
                <template v-else>{{ couponNum }}张</template>
                <a @click="jumpReceiveRecord">查看领取详情</a>
              </a-space>
            </a-descriptions-item>
            <a-descriptions-item label="每人限领">
              {{ detailData.coupon_limit }}张
            </a-descriptions-item>
            <a-descriptions-item label="领取有效期">
              <template v-if="detailData.rec_start_at && detailData.rec_start_at !== '0'">
                {{ detailData.rec_start_at | formatDate }} 至 {{ detailData.rec_end_at | formatDate }}
              </template>
              <template v-else>/</template>
            </a-descriptions-item>
            <a-descriptions-item label="使用有效期">
              <span v-if="detailData.use_type == '1'">长期有效</span>
              <div class="" v-else-if="detailData.use_type == '2'">
                <div v-if="detailData.use_eff_start_at && detailData.use_eff_start_at !== '0'">{{ detailData.use_eff_start_at | formatDate }} 至 {{ detailData.use_eff_end_at | formatDate }}</div>
                <div v-else>/</div>
              </div>
              <span v-else-if="detailData.use_type == '3'">
                领取后即时生效，有效天数 <span style="color: #1890ff;">{{ `${detailData.use_rec_eff_day}天` }}</span>
              </span>
            </a-descriptions-item>
          </a-descriptions>
        </a-col>
      </a-row>
      <a-row :gutter="[80,40]">
        <a-col :span="12">
          <a-descriptions title="使用限制" :column="1">
            <a-descriptions-item label="适用商品">
              <template v-if="detailData.use_range_type =='1'">全场通用</template>
              <template v-else-if="detailData.use_range_type =='2'">
                仅指定业务线可用
                <a-space class="flex-wrap">
                  <a-tag color="blue" v-for="business in detailData.useBusiness" :key="business.line_id">
                    {{ business.org }}
                  </a-tag>
                </a-space>
              </template>
              <template v-else-if="detailData.use_range_type =='3'">
                仅指定订单可用（订单号：{{ orderSN }}）
              </template>
            </a-descriptions-item>
            <a-descriptions-item label="使用平台">
              <a-space>
                <a-tag color="blue" v-for="platName in platList" :key="platName">
                  {{ platName }}
                </a-tag>
              </a-space>
            </a-descriptions-item>
            <a-descriptions-item label="互斥规则" :span="2">
              {{ showName('USE_RULE', detailData.use_rule) }}
              <span class="gray-text-7">（{{ detailData.use_is_more_order === '1' ? '仅允许一单使用' : '可多个订单组合使用' }}）</span>
            </a-descriptions-item>
          </a-descriptions>
        </a-col>
        <a-col :span="12">
          <a-descriptions title="其他设置" :column="1">
            <a-descriptions-item label="费用承担方">
              <template v-if="detailData.money_from === '1'">
                官方承担（不减少销售业绩，网店体系业务承担）
              </template>
              <template v-else-if="detailData.money_from === '2'">
                业务承担（减少销售业绩）
              </template>
            </a-descriptions-item>
            <a-descriptions-item label="退款退券">
              <template v-if="detailData.refund_rule === '1'">
                退款不返还优惠券
              </template>
              <template v-else-if="detailData.refund_rule === '2'">
                订单退款或取消时，退还优惠券
                <span class="gray-text-7">(多个订单使用同一张优惠券时，需全部订单退还才会退回优惠券）</span>
              </template>
            </a-descriptions-item>
            <a-descriptions-item label="排序值">
              {{ detailData.coupon_sort }}
            </a-descriptions-item>
          </a-descriptions></a-col>
      </a-row>
    </a-card>
  </div>
</template>
<script>
import { reactive, onMounted, toRefs, computed, getCurrentInstance } from '@vue/composition-api'
import { couponDetail } from '@/api/coupon/index'
import computedFun from '@/views/coupon/computed/'
import api from '@/api/'

export default {
  components: {},
  setup(props, { root }) {
    const _this = getCurrentInstance()
    const couponID = computed(() => _this.$route.params.id)
    // 优惠券名称
    const couponName = computed(() => state.platformList.find(item => +item.project === +_this.project)?.name)

    const coupon_way = computed(() => state.detailData.coupon_way)
    const coupon_target = computed(() => state.detailData.coupon_target)
    // 是否为指定用户
    const isSpecifiedStaff = computed(() => ['3'].includes(coupon_target.value))
    // 发放总量
    const couponNum = computed(() => {
      if (isSpecifiedStaff.value && Array.isArray(state.detailData.users)) {
          return state.detailData.users.length * state.detailData.coupon_limit
      } else if (['1', '2'].includes(coupon_target) && ['2'].includes(coupon_way.value)) {
        return 0
      }
      return state.detailData.coupon_num
    })

    // 订单号
    const orderSN = computed(() => {
      if (Array.isArray(state.detailData.useOrders) && state.detailData.useOrders.length) {
        return state.detailData.useOrders[0]?.order_sn
      }
      return '-'
    })

    // 平台
    const platList = computed(() => {
      const list = []
      if (Array.isArray(state.detailData.usePlat)) {
        const platIds = state.detailData.usePlat.map(plat => plat.plat_id)
        for (const key in _this.COUPON_PLAT) {
          if (Object.hasOwnProperty.call(_this.COUPON_PLAT, key)) {
            if (platIds.includes(key)) {
              list.push(_this.COUPON_PLAT[key])
            }
          }
        }
      }
      return list
    })

    const state = reactive({
      form: {},
      title: '优惠券详情',
      submitLoading: false,
      platformList: [], // 发布平台
      detailData: {},
      project: _this.$route.query.project,
    })

    onMounted(async () => {
      methods.getPlatform()
      const id = couponID.value
      if (id) {
        getDetail()
      }
    })

    async function getDetail() {
      state.submitLoading = true
      const res = await couponDetail({ id: couponID.value })
      if (_this.$validate(res)) {
        state.detailData = res.data
      }
      state.submitLoading = false
    }

    const methods = {
      // 获取平台列表
      async getPlatform() {
        const res = await api.LineListNew()
        state.platformList = res.data
      },
      jumpReceiveRecord() {
        const id = state.detailData.id
        this.$router.push({
          name: 'receiveRecords',
          // params: {
          //   id
          // },
          query: {
            id
          }
        })
      },
      back() {
        this.$router.push('/coupon-manager')
      }
    }

    return {
      ...toRefs(state),
      ...computedFun(),
      ...methods,
      getDetail,
      couponName,
      couponID,
      couponNum,
      orderSN,
      platList
    }
  }
}
</script>

<style lang="less" scoped>
  .couponId {
    font-size: 12px;
    color: #8c8c8c;
    font-weight: normal;
  }
  .coupon-detail-container  {
    /deep/ .ant-descriptions-title {
      margin-bottom: 16px;
    }
    /deep/ .ant-descriptions-view {
      border: 1px solid #ebeef5;
      padding: 16px;
      // margin-left: -16px;
      // margin-left: -16px;
      border-radius: 4px;
      min-height: 180px;
      transition: all .3s;
      &:hover {
        box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
      }
      .ant-descriptions-item {
        display: flex;
      }
    }
  }
  .flex-wrap{
    flex-wrap: wrap;
  }
</style>
